/**
 * Cross-Portal Service for Ufficio Stile Portal
 * 
 * Provides functionality to complete requests and notify other portals
 * as part of the FASE 6 workflow implementation.
 */

import { apiClient } from './base';

export interface CrossPortalCompletionRequest {
  requestId: string;
  revisionId?: string;
  completionNotes?: string;
  userId: string;
  userName?: string;
  userRole?: string;
  notifyPortals?: string[];
  completedAt?: string;
}

export interface CrossPortalCompletionResponse {
  success: boolean;
  completionId: string;
  completedAt: string;
  notifiedPortals: string[];
  workflowState: string;
  message?: string;
}

export class CrossPortalService {
  private baseUrl = '/api/cross-portal';

  /**
   * Complete a request and notify other portals
   */
  async completeAndNotify(request: CrossPortalCompletionRequest): Promise<CrossPortalCompletionResponse> {
    const response = await apiClient.post<CrossPortalCompletionResponse>(
      `${this.baseUrl}/complete-and-notify`,
      {
        requestId: request.requestId,
        revisionId: request.revisionId || '',
        completionNotes: request.completionNotes || '',
        userId: request.userId,
        userName: request.userName || '',
        userRole: request.userRole || 'User',
        notifyPortals: request.notifyPortals || ['Personalizzati', 'Configuratore'],
        completedAt: request.completedAt
      }
    );
    return response as unknown as CrossPortalCompletionResponse;
  }

  /**
   * Get cross-portal request status
   */
  async getRequestStatus(requestId: string): Promise<any> {
    const response = await apiClient.get<any>(`${this.baseUrl}/status/${requestId}`);
    return response.data;
  }

}

export const crossPortalService = new CrossPortalService();
